import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? '';
export const DEV_USER_ID_STORAGE_KEY = 'talegence.devUserId';

export const getRequestErrorMessage = (err: unknown, fallback: string): string => {
  const responseData =
    typeof err === 'object' && err !== null && 'response' in err
      ? (err as { response?: { data?: { detail?: unknown; message?: unknown } } }).response?.data
      : undefined;

  if (typeof responseData?.detail === 'string') {
    return responseData.detail;
  }
  const detail = responseData?.detail;
  if (Array.isArray(detail)) {
    const firstMessage = detail
      .map((item) => {
        if (typeof item === 'string') {
          return item;
        }
        if (
          typeof item === 'object' &&
          item !== null &&
          'msg' in item &&
          typeof (item as { msg?: unknown }).msg === 'string'
        ) {
          return (item as { msg: string }).msg;
        }
        return null;
      })
      .find(Boolean);
    if (firstMessage) {
      return firstMessage;
    }
  }
  if (typeof responseData?.message === 'string') {
    return responseData.message;
  }
  return fallback;
};

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    if (typeof FormData !== 'undefined' && config.data instanceof FormData && config.headers) {
      const headers = config.headers as Record<string, unknown> & {
        delete?: (header: string) => void;
      };
      if (typeof headers.delete === 'function') {
        headers.delete('Content-Type');
        headers.delete('content-type');
      } else {
        delete headers['Content-Type'];
        delete headers['content-type'];
      }
    }
    // Add auth token if available
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const devUserId =
      localStorage.getItem(DEV_USER_ID_STORAGE_KEY) || process.env.REACT_APP_DEV_USER_ID;
    if (devUserId) {
      config.headers['X-User-Id'] = devUserId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
